import styled from 'styled-components';
import MuiRadioGroup from '@mui/material/RadioGroup';

export const Radio = styled(MuiRadioGroup)`
  .MuiSvgIcon-root {
    color: ${(props) => props.theme.radio.border};
  }

  .Mui-checked {
    .MuiSvgIcon-root {
      color: ${(props) => props.theme.primary.main};
    }
  }

  .MuiTypography-root {
    color: ${(props) => props.theme.palette.text.primary};
  }
`;
